import type { IntlShape } from 'react-intl/src/types';
import type { InferType } from 'yup';
import { bool, object, string } from 'yup';

import { formMessages } from '@/messages/forms';

export type WarrantyExtensionSchema = InferType<
  ReturnType<typeof warrantyExtensionSchema>
>;

export const warrantyExtensionSchema = (
  formatMessage: IntlShape['formatMessage'],
) => {
  const requiredMsg = formatMessage(formMessages.requiredField);

  const schema = object({
    rn: string().required(requiredMsg).default(''),
    sn: string().required(requiredMsg).default(''),
    captcha: bool().default(false).oneOf([true], requiredMsg),
  });
  return schema;
};
